import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import EventBusyRoundedIcon from "@mui/icons-material/EventBusyRounded";
import GradeRoundedIcon from "@mui/icons-material/GradeRounded";
import GroupAddRoundedIcon from "@mui/icons-material/GroupAddRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import InventoryRoundedIcon from "@mui/icons-material/InventoryRounded";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonAddDisabledRoundedIcon from "@mui/icons-material/PersonAddDisabledRounded";
import PersonAddRoundedIcon from "@mui/icons-material/PersonAddRounded";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import type { SvgIconProps } from "@mui/material";
import { type UserNotification } from "@prisma/client";

/**
 * # Hover over each icon to see a preview of that icon
 *
 * -----
 *
 * For developers adding icons, please add an image that looks similar to the icon you used
 */
export enum NotificationIcon {
  /**
   * ![Icon](data:image/png;base64,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)
   */
  INFO = "info",
  /**
   * ![Icon](data:image/png;base64,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)
   */
  USER_ADD = "newUser",
  /**
   * ![Icon](https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0qewK8xM9QjLVqIFMW6Q8Yrks_c1aiTT1gw&s)
   */
  NEW_USER_IN_GROUP = "newUserInGroup",
  /**
   * ![Icon](https://images.icon-icons.com/1863/PNG/512/person-add-disabled_118817.png)
   */
  USER_CANCELED = "userCancel",
  /**
   * ![Icon](https://cdn.iconscout.com/icon/free/png-256/free-event-busy-icon-download-in-svg-png-gif-file-formats--no-notification-pack-user-interface-icons-1514392.png)
   */
  EVENT_CANCELED = "eventCanceled",
  /**
   * ![Icon](https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQBKUVt75BRU2QtRcrxtl-hFOA16Mre-FS9EQ&s)
   */
  FULL_CALENDAR = "fullCalendar",
  /**
   * ![Icon](https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZydQqkyX5X5S44zo3PR5zF3ZLWsmGGsa-BQ&s)
   */
  FULL_EVENT = "fullEvent",
  /**
   * ![Icon](https://i.pinimg.com/564x/4f/fc/ea/4ffceabc15dfde5f9638564670171517.jpg)
   */
  WARNING = "warning",
  /**
   * ![Icon](https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Cancel_icon.svg/2048px-Cancel_icon.svg.png)
   */
  CANCEL = "cancel",
  /**
   * ![Icon](https://www.iconpacks.net/icons/1/free-star-icon-346-thumb.png)
   */
  NEW = "new",
  /**
   * ![Icon](https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTdmPEQjcIW5E0Nf2LBZFmtN8Pp04cmn6XX6g&s)
   */
  GROUP = "group",
  /**
   * ![Icon](https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQeUzNnrwPUFY4oN-My9KauGfZ3AiScpgwkOg&s)
   */
  LOGOUT = "logout",
  /**
   * ![Icon](https://cdn-icons-png.flaticon.com/512/483/483593.png)
   */
  CLOCK = "clock",
}

const NOTIFICATION_ICON_MAP: Record<
  (typeof NotificationIcon)[keyof typeof NotificationIcon],
  React.ElementType<SvgIconProps>
> = {
  info: InfoRoundedIcon,
  newUser: PersonAddRoundedIcon,
  fullCalendar: EventAvailableRoundedIcon,
  warning: WarningRoundedIcon,
  cancel: CancelRoundedIcon,
  new: GradeRoundedIcon,
  userCancel: PersonAddDisabledRoundedIcon,
  fullEvent: InventoryRoundedIcon,
  eventCanceled: EventBusyRoundedIcon,
  newUserInGroup: GroupAddRoundedIcon,
  group: GroupsRoundedIcon,
  logout: LogoutIcon,
  clock: WatchLaterIcon,
};

export type NotificationTemperature = "error" | "warning" | "success" | "info";

const NOTIFICATION_ICON_TEMPERATURE_MAP: Record<
  (typeof NotificationIcon)[keyof typeof NotificationIcon],
  NotificationTemperature
> = {
  info: "info",
  newUser: "success",
  newUserInGroup: "success",
  userCancel: "error",
  eventCanceled: "error",
  fullCalendar: "success",
  warning: "warning",
  cancel: "error",
  new: "success",
  group: "success",
  logout: "error",
  fullEvent: "success",
  clock: "info",
};

export const NOTIFICATION_ICONS = Object.keys(NOTIFICATION_ICON_MAP);

export function getNotificationIcon(notification: UserNotification) {
  return NOTIFICATION_ICON_MAP[
    (notification.icon as keyof typeof NOTIFICATION_ICON_MAP) ?? "info"
  ];
}

export function getNotificationTemperature(notification: UserNotification) {
  return NOTIFICATION_ICON_TEMPERATURE_MAP[
    (notification.icon as keyof typeof NOTIFICATION_ICON_TEMPERATURE_MAP) ??
      "info"
  ];
}
